import { Component, AfterViewInit, EventEmitter, Output, AfterContentInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent,  NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
// import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UsuarioService } from '../../services/Usuario.service';
import { Cliente, MDC, Usuario } from '../../interfaces/beans.interface';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UsuarioMDCService } from '../../services/usuario.mdc.service';
declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  // public config: PerfectScrollbarConfigInterface = {};
  public showSearch = false;
  usuario: Usuario = <Usuario>{};
  clientes: Cliente[] = [];
  mdcs: MDC[] = [];
  idCliente: string;
  idMDC: string;
  mostrarCabecera: boolean = false;
  rfcUsuario: string;
  nombre: string;

  constructor(private usuarioService: UsuarioService, private usuarioMDCService: UsuarioMDCService, private toastr: ToastrService, private router: Router) {
    this.obtenerClientes();
    this.rfcUsuario = localStorage.getItem('idUsuario');
    this.nombre = localStorage.getItem('nombre');
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      btn: 'btn-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      btn: 'btn-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      btn: 'btn-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      btn: 'btn-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  ngAfterViewInit() {}

  obtenerClientes() {
    /*let idUsuario = localStorage.getItem('idUsuario');
    this.usuarioService.getByUsername(idUsuario).subscribe(
      messageClientes => {
        if (messageClientes['httpStatus'] === 200) {
          this.usuario = messageClientes['usuario'];
          let user = messageClientes['usuario'];
          this.clientes = user.clientes;
          localStorage.setItem('idCliente', this.clientes[0].id);
          this.idCliente = this.clientes[0].id;
          this.obtenerMDCs();
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los clientes asignados al usuario');
        } else if (error.status === 403) {
          this.goLogin();
        }
      }
    ); */
  }

  changeCliente() {
    localStorage.setItem('idCliente', this.idCliente);
    this.obtenerMDCs();
  }

  obtenerMDCs() {
    this.mdcs = [];
    let idUsuario = localStorage.getItem('idUsuario');
    let idCliente = localStorage.getItem('idCliente');
    this.usuarioMDCService.getAll(idUsuario, idCliente).subscribe(
      messageMDCs => {
        if (messageMDCs['httpStatus'] === 200) {
          let usuariosMDC = messageMDCs['usuariosMDC'];
          if (usuariosMDC.length > 0) {
            for (let usuarioMDC of usuariosMDC) {
              this.mdcs.push(usuarioMDC.mdc);
            }
            localStorage.setItem('idMdc', this.mdcs[0].id);
            this.idMDC = this.mdcs[0].id;
            this.router.navigate(['dashboard/pedidos']);
          } else {
            this.mostrarCabecera = true;
          }
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los MDCs asignados al usuario');
        } else if (error.status === 403) {
          this.goLogin();
        }
      }
    );
  }

  changeMDC() {
    if (this.idMDC !== '-1') {
      localStorage.setItem('idMdc', this.idMDC);
      this.router.navigate(['dashboard/pedidos']);
    }
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  goLogin() {
    localStorage.clear();
    this.router.navigate(['']);
  }

  goModificarContrasena() {
    //this.router.navigate(['administracion/modificarContrasena/primerLogin']);
    this.router.navigate(['administracion/modificarContrasena/nuevaPass']);
  }

  goModificarCuenta() {
    this.router.navigate(['administracion/primerLogin']);
  }
}
